import UserSMSDevice from './UserSMSDevice';

export default UserSMSDevice;
